import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  balance: 0,
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setBalance: (state, action) => {
      state.balance = action.payload;
    },
    incrementBalance: (state, action) => {
      state.balance += action.payload;
    },
    decrementBalance: (state, action) => {
      state.balance -= action.payload;
    },
    resetBalance: (state) => {
      state.balance = 0;
    },
  },
});

export const { setBalance, incrementBalance, decrementBalance, resetBalance } = accountSlice.actions;
export const selectBalance = (state) => state.account.balance;
export default accountSlice.reducer;
